<template>
    <ReportWrapper>
        <template v-slot:title>
            Historical Inventory List File Uploads
        </template>
        <UploadedFilesList :ee-code="eeCode" />
    </ReportWrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import UploadedFilesList from '$Components/UploadedFilesList';
import ReportWrapper from './ReportWrapper';

export default {
    name: 'HistoricalInventoryUploads',

    components: {
        UploadedFilesList,
        ReportWrapper
    },

    data() {
        return {};
    },

    computed: {
        ...mapGetters({
            userPersona: 'auth/userPersona',
        }),

        eeCode() {
            return this.userPersona.applicant_id;
        },
    },
};
</script>


<style lang='scss'>
</style>
